"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Store = exports.ArrayStore = exports.BaseSimpleEvent = exports.BaseEvent = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class BaseEvent {
    constructor(item, event, args) {
        this.item = item;
        this.event = event;
        this.args = args;
    }
}
exports.BaseEvent = BaseEvent;
class BaseSimpleEvent extends BaseEvent {
}
exports.BaseSimpleEvent = BaseSimpleEvent;
class ArrayStore {
    constructor(eventClazz, initalVal, dependsOn) {
        this.eventClazz = eventClazz;
        this.dependsOn = dependsOn;
        this._equalOperator = (a, b) => a == b;
        this._state = new rxjs_1.BehaviorSubject([]);
        this._subject = new rxjs_1.Subject();
        this._observable = this._subject.asObservable();
        this._restSubj = new rxjs_1.Subject();
        this._restObs = this._restSubj.asObservable();
        if (dependsOn) {
            // if theres a dependence (ie this is a subset of another collection)
            dependsOn.events.subscribe(ev => {
                if (ev.event == 'REMOVE') {
                    this.remove(ev.item);
                }
                else if (ev.event == 'UPDATE') {
                    var f = this._state.getValue().find(s => s == ev.item);
                    if (f) {
                        this.emmit(f, 'UPDATE');
                    }
                }
            });
        }
    }
    set values(newVals) {
        var curState = this._state.getValue().slice();
        this._state.next(newVals.slice());
        this._restSubj.next(newVals.slice());
        var toDel = curState.filter(p => !newVals.find(pp => this._equalOperator(pp, p)));
        toDel.forEach(p => this._subject.next(new this.eventClazz(p, 'REMOVE')));
        var toAdd = newVals.filter(p => !curState.find(pp => this._equalOperator(pp, p)));
        toAdd.forEach(p => this._subject.next(new this.eventClazz(p, 'ADD')));
    }
    get values() {
        return this._state.getValue().slice();
    }
    /*
        get subscribe():((next?: (response:C) => void, error?: (error: any) => void, complete?: () => void) => Subscription){
            var v = this.observable
            return v.subscribe.bind(v)
        }*/
    get events() {
        var preFire = this._state.getValue().map(f => new this.eventClazz(f, 'ADD'));
        if (preFire.length)
            return (0, rxjs_1.concat)(preFire, this._observable);
        else
            return this._observable;
    }
    get state() {
        return this._state;
    }
    get restState() {
        return this._restObs;
    }
    setEqualOperator(op) {
        this._equalOperator = op;
        return this;
    }
    add(o) {
        this.set(o);
    }
    addAll(a) {
        this.setAll(a);
        return this;
    }
    set(o) {
        if (!this.values.find(pp => this._equalOperator(pp, o))) {
            var newA = this.values;
            newA.push(o);
            this.values = newA;
        }
        else
            this.emmit(o, 'UPDATE');
    }
    setAll(a) {
        if (a)
            a.forEach(aa => this.set(aa));
        return this;
    }
    contains(d) {
        return !!this.values.find(f => this._equalOperator(f, d));
    }
    remove(o) {
        //  if(this._state.find(pp => pp == o)){
        //if(!quietly) this.emmit(o,this.removeEvent)
        this.values = this.values.filter(pp => !this._equalOperator(pp, o));
        // }
    }
    emmit(o, event, args) {
        this._subject.next(new this.eventClazz(o, event, args));
    }
    /*
    bindArray(a:OBJ[], fn?:((C) => any)):Subscription{
        return this.events.subscribe(ev => {
            if(ev.event == 'ADD'){
                a.push(ev.item)
                if(fn)
                    fn(ev)
            }
            else if(ev.event == 'REMOVE'){
                a.splice(a.indexOf(ev.item),1)
                if(fn)
                    fn(ev)

            }
        })
    }*/
    close() {
        this._subject.complete();
    }
}
exports.ArrayStore = ArrayStore;
class Store {
    constructor(eventClazz, inital) {
        this.eventClazz = eventClazz;
        this._state = new rxjs_1.BehaviorSubject(null);
        this._subject = new rxjs_1.Subject();
        this._observable = this._subject.asObservable();
        this._restSubj = new rxjs_1.Subject();
        this._restObs = this._restSubj.asObservable();
        this._equalOperator = (a, b) => a == b;
        if (inital)
            this.value = inital;
    }
    set value(newVal) {
        var oldVal = this.value;
        var isSame = this._equalOperator(this.value, newVal);
        // Not sure, should i be firing this is the object being set is the same!?
        this._state.next(newVal);
        this._restSubj.next(newVal);
        if (isSame) {
            this.emmit('UPDATE');
        }
        else {
            // if preivous state, clear
            if (oldVal)
                this.emmit('REMOVE', null, oldVal);
            // if new state not null emmit
            if (this._state.value)
                this.emmit('ADD', this._args);
        }
    }
    get value() {
        return this._state.getValue();
    }
    /**
     * Get the state, will fire immeidatley on subscribe even if null
     */
    get state() {
        return this._state;
    }
    /**
     * The resting state, wont fire if already set, only fires if changes after subscribed to
     */
    get restState() {
        return this._restObs;
    }
    /**
     * Get the state, will fire immeidatley on subscribe even if null
     */
    get readyState() {
        return this._state.pipe((0, operators_1.filter)(a => !!a));
    }
    /**
     * Return first non-null value
     */
    get onReady() {
        return this.state.pipe((0, operators_1.first)(a => !!a));
    }
    /*
    get subscribe():((next?: (response:C) => void, error?: (error: any) => void, complete?: () => void) => Subscription){
        var v = this.observable
        return v.subscribe.bind(v)
    }*/
    get events() {
        if (this.value)
            return (0, rxjs_1.concat)([new this.eventClazz(this._state.getValue(), 'ADD', this._args)], this._observable);
        else
            return this._observable;
    }
    setWithArgs(o, args) {
        this._args = args;
        this.value = o;
    }
    emmit(event, args, o) {
        if (!(o || this._state))
            throw new Error('cant emmit with no object');
        this._subject.next(new this.eventClazz(o || this._state.getValue(), event, args));
    }
    close() {
        this._subject.complete();
    }
    exists(fn) {
        if (this.value)
            return fn(this.value);
        else
            return false;
    }
    setEqualOperator(op) {
        this._equalOperator = op;
        return this;
    }
}
exports.Store = Store;
